export default {"src":"/_next/static/media/ico_minus.4ce7d0ef.svg","height":4,"width":16,"blurWidth":0,"blurHeight":0};